var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScarica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.4666 64.4C48.4666 64.4 48.5666 64.5 48.6666 64.6C48.8666 64.8 49.0666 65 49.2666 65.1C49.3666 65.1 49.3666 65.2 49.4666 65.2L49.5666 65.3C50.2666 65.6 50.9666 65.7 51.8666 65.3C51.8666 65.3 51.9666 65.3 51.9666 65.2C52.0666 65.2 52.0666 65.1 52.1666 65.1C52.4666 64.9 52.6666 64.8 52.7666 64.6L52.8666 64.5L62.4666 51.7C63.0666 50.9 63.1666 49.8 62.7666 48.8C62.2666 47.9 61.3666 47.3 60.2666 47.3H53.3666V14.7C53.3666 13.2 52.1666 12 50.6666 12C49.1666 12 47.9666 13.2 47.9666 14.7V47.2H41.0666C40.0666 47.2 39.0666 47.8 38.5666 48.7C38.0666 49.6 38.1666 50.7 38.8666 51.6L48.4666 64.4Z",
    fill: "#1F1F1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9666 60.1C84.4666 60.1 83.2666 61.3 83.2666 62.8V72.4C83.2666 78 78.7666 82.5 73.1666 82.5H28.1666C22.5666 82.5 18.0666 78 18.0666 72.4V62.8C18.0666 61.3 16.8666 60.1 15.3666 60.1C13.8666 60.1 12.6666 61.3 12.6666 62.8V72.4C12.6666 81 19.6666 88 28.1666 88H73.0666C81.6666 88 88.6666 81 88.6666 72.5V62.9C88.6666 61.3 87.4666 60.1 85.9666 60.1Z",
    fill: "#1F1F1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScarica);
export default __webpack_public_path__ + "static/media/scarica.f107335ecebf52b0a3448ae73e281a35.svg";
export { ForwardRef as ReactComponent };